// Sign-aware rendering of a customer's running Account Balance — the stored
// `DepositBalance` column (the column/DTO/endpoint name is unchanged; only the
// UI vocabulary becomes "Account Balance"). Positive = on deposit (shown CR),
// negative = amount the customer owes (shown "due"), zero = settled.
//
// See v1.4 Item 1. Reused by the receipt-creation field and the receipt detail
// view (Item 5). Color tokens reuse the app's existing green-700 (positive) and
// red-700 (attention) usage — no new design system, no new deps.

/** `$` + absolute value, e.g. -50 and 50 both render as "$50.00". */
export function formatAccountMoney(value: number): string {
  return `$${Math.abs(value).toFixed(2)}`;
}

export interface AccountBalanceDisplay {
  /** Primary text: "$50.00 CR", "$50.00 due", or "Settled". */
  text: string;
  /** Secondary helper: "On deposit", "Outstanding", or "" when settled. */
  helper: string;
  /** Tailwind color class for the primary text. */
  className: string;
}

export function accountBalanceDisplay(balance: number): AccountBalanceDisplay {
  if (balance > 0)
    return { text: `${formatAccountMoney(balance)} CR`, helper: 'On deposit', className: 'text-green-700' };
  if (balance < 0)
    return { text: `${formatAccountMoney(balance)} due`, helper: 'Outstanding', className: 'text-red-700' };
  return { text: 'Settled', helper: '', className: 'text-slate-600' };
}
